<template>
    <AuthPageInner title="Reset Password">
        <ResetPasswordForm
            ref="form"
            :token="$route.params.token"
            :email="$route.query.email"
            @success="onSuccess" />
    </AuthPageInner>
</template>

<script>

import AuthPageInner from "@/Components/Layout/AuthPageInner";
import ResetPasswordForm from "@/Components/Auth/ResetPasswordForm";

export default {

    name: "ResetPasswordPage",

    components: {
        AuthPageInner,
        ResetPasswordForm
    },

    mounted() {
        this.$nextTick(() => {
            this.$refs.form.focus();
        });
    },

    methods: {
        onSuccess() {
            this.$router.push({name: 'login'});
        }
    }
}
</script>
